import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material'
import { Provider } from 'react-redux'
import { store } from './store'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import TeamsPage from './pages/TeamsPage'
import CasesPage from './pages/CasesPage'
import MemorialsPage from './pages/MemorialsPage'
import EvidencePage from './pages/EvidencePage'
import ScoringPage from './pages/ScoringPage'
import ProfilePage from './pages/ProfilePage'
import UsersPage from './pages/UsersPage'
import NotificationsPage from './pages/NotificationsPage'
import CourtroomPage from './pages/CourtroomPage'
import ReportsPage from './pages/ReportsPage'
import KnowledgeLibraryPage from './pages/KnowledgeLibraryPage'
// DocumentsPage và RAGSearchPage đã được tích hợp vào CasesPage

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#667eea',
      light: '#8b9ef5',
      dark: '#5568d3',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#764ba2',
      light: '#9575b5',
      dark: '#6a3f8f',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        },
      },
    },
  },
})

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ 
          minHeight: '100vh',
          width: '100%',
          margin: 0,
          padding: 0,
        }}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
              <Route path="teams" element={<ProtectedRoute><TeamsPage /></ProtectedRoute>} />
              <Route path="cases" element={<ProtectedRoute><CasesPage /></ProtectedRoute>} />
              <Route path="memorials" element={<ProtectedRoute><MemorialsPage /></ProtectedRoute>} />
              <Route path="evidence" element={<ProtectedRoute><EvidencePage /></ProtectedRoute>} />
              <Route path="scoring" element={<ProtectedRoute allowedRoles={['admin', 'judge', 'secretary']}><ScoringPage /></ProtectedRoute>} />
              <Route path="courtroom" element={<ProtectedRoute><CourtroomPage /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute allowedRoles={['secretary', 'support']}><ReportsPage /></ProtectedRoute>} />
              <Route path="knowledge" element={<ProtectedRoute><KnowledgeLibraryPage /></ProtectedRoute>} />
              <Route path="notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
              <Route path="profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </Box>
      </ThemeProvider>
    </Provider>
  )
}

export default App
